import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as standingsThunks from "../../../../redux/thunks/standingsThunks";
import standingsActions from "../../../../redux/reducers/standingsReducer/standingsActions";
import StandingsTable from "./StandingsTable";

const StandingsTableContainer = ({
  organizerId,
  tournamentId,
  loading,
  standings,
  loadPositions,
  clearAllStandings,
  show,
}) => {
  useEffect(() => {
    clearAllStandings();
    loadPositions(organizerId, tournamentId);
  }, []);

  return (
    show && (
      <StandingsTable
        standings={standings}
        loading={loading.standings.loadPositions}
      />
    )
  );
};

const mapState = (state) => ({
  loading: state.loading,
  standings: state.standings.all,
});

const mapDispatch = (dispatch) => ({
  loadPositions: (organizerId, tournamentId) =>
    dispatch(standingsThunks.loadPositions(organizerId, tournamentId)),
  clearAllStandings: () =>
    dispatch(standingsActions.clearAllStandings()),
});

export default withRouter(
  connect(mapState, mapDispatch)(StandingsTableContainer)
);
